import Header from "../Header/Header";

const Confirmation = () => {
  return (
    <div>
      <Header
        title="Verify Your Email"
        textBackground="Verify Your Email"
        backgroundImg="http://res.cloudinary.com/brabenjos/image/upload/v1729584914/sodastream/1729584914532.png"
        subTitle=""
        desktopHeight="auto"
      />
      <section className="relative w-full mt-[-35%] z-50 mb-5 p-4">
        <div className="md:relative gap-10 z-50 flex flex-col items-center justify-center w-full">
          <div className="bg-white rounded-xl border-[0.5px] border-[#75A7AD] relative sm:w-[50%]
           opacity-80 px-10 py-20 text-[#005D6E]">
            <div className="bg-white p-6 rounded-lg flex flex-col items-center mt-[-13%]">
            <h2 className="mt-4 text-2xl font-bold text-[#75A7AD]">
               Welcome to Sodastream!
              </h2>
              <p className="mt-2 text-lg text-gray-700 text-center">
              Your SodaStream account has been successfully created!
             
                <br />
                Please verify your email address to complete your registration.
              </p>
              <p className="mt-2 text-lg text-gray-700 text-center"> If you don't receive the verification email, be sure to check your Junk or Spam folder.​
              ​​</p>
             
            </div>
          </div>
        </div>
        
      </section>
    </div>
  );
};

export default Confirmation;
